import { jsxs, jsx } from "react/jsx-runtime";
const IconPositiveSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1Zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9Z" }),
      /* @__PURE__ */ jsx("path", { d: "M15.3 9.3 11 13.6l-1.3-1.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2c.2.2.5.3.7.3.2 0 .5-.1.7-.3l5-5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0Z" })
    ]
  }
);
export {
  IconPositiveSvg
};
